export default "__VITE_ASSET__d70216f2__"